import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  accordion: {
    boxShadow: 'none',
  },
  accordionDetails: {
    borderTop: `dashed 1px ${theme.palette.grey[200]}`,
    padding: theme.spacing(2),
  },
  accordionRow: {
    '& > div': {
      flex: '1 auto',
      display: 'flex',
      alignItems: 'center',

      '& > p': {
        marginLeft: theme.spacing(1.5),
        fontWeight: 500,
      },
    },

    '& > p:last-child': {
      color: theme.palette.grey[500],
      fontSize: theme.typography.fontSize,
      marginRight: theme.spacing(3),
    },
  },
  accordionDisabled: {
    pointerEvents: 'none',

    '& svg': {
      opacity: 0,
    },
  },
  wrapperInnerContent: {
    padding: theme.spacing(2, 1),

    '& table tr': {
      '& svg': {
        marginRight: theme.spacing(1),
        position: 'relative',
        top: theme.spacing(0.5),
        transform: 'rotate(-90deg)',
      },

      '& th': {
        fontSize: '1rem',
        border: 'none',
        padding: theme.spacing(1),

        '&:last-child': {
          fontWeight: 500,
        },
      },
    },
  },
  wrapperContent: {
    backgroundColor: theme.palette.grey[200],
    maxHeight: '60vh',
  },
  wrapperHead: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(0.5),
    marginBottom: theme.spacing(1.75),

    '& > svg': {
      position: 'relative',
      top: '-1px',
    },
  },
  wrapperTitle: {
    zIndex: 2,

    '& h6': {
      marginLeft: theme.spacing(1),
    },
  },
}));
